import MainLayout from 'layouts/MainLayout';
import ForeignAgentKrik from 'components/ForeignAgentKrik';
import React, { lazy } from 'react';

const NewslettersContent = lazy(() => import('content/Newsletters'));

const Newsletters = () => (
	<MainLayout>
		<ForeignAgentKrik dark />
		<NewslettersContent />
	</MainLayout>
);
export default Newsletters;
